import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AlloyService } from 'src/app/shared/alloy/alloy.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-edit-alloys',
    templateUrl: './edit-alloys.component.html',
    styleUrls: ['./edit-alloys.component.scss'],
    standalone: false
})
export class EditAlloysComponent implements OnInit {

  alloy: {}
  loading: boolean = true
  role: string
  gIron = ['Grey Iron','Ductile Iron']
  ironType = ['Base Iron','Final Iron']
  serverErrorMessages: string
  serverSuccessMessage: string
  editGELWEL: boolean = false
  alloyForm = new FormGroup ({
    name: new FormControl(''),
    iron1: new FormControl('Grey Iron'),
    iron2: new FormControl('Base Iron'),
    greyIron: new FormGroup({
      baseIron: new FormControl(false),
      finalIron: new FormControl(false),
    }),
    ductileIron: new FormGroup({
      baseIron: new FormControl(false),
      finalIron: new FormControl(false),
    }),
    grade: new FormControl('',[Validators.required]),
    chemistry: new FormGroup({
      C: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Si: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Mn: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      P: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      S: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Cr: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Cu: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Mg: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Ni: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Mo: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      V: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Fe: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(100),
          max: new FormControl(100),
        }),
        mean: new FormControl(100)
      }),
      Sn: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Nb: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      B: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      W: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Zn: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Pb: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Ti: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
      Sr: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(100),
        }),
        mean: new FormControl(0)
      }),
    }),
    calculatedValues: new FormGroup({
      GRADE: new FormControl(''),
      GEL: new FormControl(''),
      WEL: new FormControl(''),

    }),
    TLcalculatedValues: new FormGroup({
      TL_REF: new FormControl(''),
    })
  });
  dropdownList = [];
  dropdownSettings: IDropdownSettings;
  constructor(private loginService: LoginService, private alloyService: AlloyService, private router : Router) { }

  ngOnInit(): void {
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )

      this.dropdownList = [
        { item_id: '1', item_text: 'Grey Iron' },
        { item_id: '2', item_text: 'Base Iron' },
        { item_id: '3', item_text: 'Ductile Iron' },
        { item_id: '4', item_text: 'Final Iron' },
      ];

      this.dropdownSettings = {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 4,
        allowSearchFilter: true
      };

      this.alloyService.currentAlloy.subscribe(alloy => {
        console.log(alloy)
        this.alloy = alloy
       //console.log('Inside edit alloys',this.alloy)
      });

      if(Object.keys(this.alloy).length === 0){
       //console.log('PLEASE GO BACK')
        window.alert('Please Select an alloy to edit')
        this.router.navigateByUrl('get-all-alloys')
      }
      else{
        this.alloyForm.get('name').setValue(this.alloy['name'])
        this.alloyForm.get('iron1').setValue(this.alloy['iron1'])
        this.alloyForm.get('iron2').setValue(this.alloy['iron2'])
        console.log(this.alloy['iron1'],this.alloy['iron2'])
        this.alloyForm.get('grade').setValue(this.alloy['grade'])
        this.alloyForm.get('chemistry').setValue(this.alloy['chemistry'])
       // alert(JSON.stringify(this.alloy['chemistry']['C']['mean']));
      //  alert((14.45-((this.alloy['chemistry']['C']['mean']))-0.25*((this.alloy['chemistry']['Si']['mean']))-0.5*-((this.alloy['chemistry']['P']['mean']))/0.0089))
        this.alloyForm.get('calculatedValues').setValue(this.alloy['calculatedValues'])
        //this.alloyForm.get('TLcalculatedValues').get('TL_REF').setValue(14.45-((this.alloy['chemistry']['C']['mean']))-0.25*((this.alloy['chemistry']['Si']['mean']))-0.5*((this.alloy['chemistry']['P']['mean']))/0.0089)
      }


     

      this.onChanges();
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  onSubmit(){
    if (this.alloyForm.get('iron1').value=="Grey Iron") {
      if (this.alloyForm.get('iron2').value=="Base Iron") {
        this.alloyForm.get('greyIron').get('baseIron').setValue(true);
      }
      else if (this.alloyForm.get('iron2').value=="Final Iron") {
        this.alloyForm.get('greyIron').get('finalIron').setValue(true);
      }
    }
    else if (this.alloyForm.get('iron1').value=="Ductile Iron") {
      if (this.alloyForm.get('iron2').value=="Base Iron") {
        this.alloyForm.get('ductileIron').get('baseIron').setValue(true);
      }
      else if (this.alloyForm.get('iron2').value=="Final Iron") {
        this.alloyForm.get('ductileIron').get('finalIron').setValue(true);
      }
    }
    this.alloyService.editAlloy({
      alloyData: this.alloyForm.value,
      alloyId: this.alloy['_id']
    }).subscribe(
      res=> {
        this.serverSuccessMessage = "Update Successful"
       //console.log('Successfully updates', res)
        // setTimeout(()=>{
        //   window.alert(this.serverSuccessMessage);
        //   this.router.navigateByUrl('/get-all-alloys');
        // }, 3000)
        window.alert(this.serverSuccessMessage);
        this.router.navigateByUrl('/get-all-alloys');
      },
      err=>{
        this.serverErrorMessages = err.error.message
       //console.log('error updating', err)
      }
    )
  }

  onChanges(){
    this.alloyForm.get('chemistry').get('C').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
          //this.alloyForm.get('chemistry').get('C').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('C').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Si').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
          //this.alloyForm.get('chemistry').get('Si').get('minmax').get('max').setValue(val.min)

        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        let GELvalue = 1153+(6.7 * (this.alloyForm.get('chemistry').get('Si').get('mean').value));
        let WELvalue = 1147-(12 * (this.alloyForm.get('chemistry').get('Si').get('mean').value));
        this.alloyForm.get('chemistry').get('Si').get('mean').setValue(num)
        this.alloyForm.get('calculatedValues').get('GEL').setValue(GELvalue.toString());
        this.alloyForm.get('calculatedValues').get('WEL').setValue(WELvalue.toString());
        ////console.log(val)
      } 
    );

    this.alloyForm.get('chemistry').get('Mn').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
          //this.alloyForm.get('chemistry').get('Mn').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Mn').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('P').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
          //this.alloyForm.get('chemistry').get('P').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('P').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('S').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('S').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('S').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Cr').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('Cr').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Cr').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Cu').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Cu').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Cu').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Mg').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Mg').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Mg').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Ni').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Ni').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Ni').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Mo').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Mo').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Mo').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('V').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('V').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('V').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Fe').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Fe').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Fe').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Sn').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Sn').get('minmax').get('max').setValue(val.min+1)
         }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Sn').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Nb').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Nb').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Nb').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('B').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('B').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('B').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('W').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('W').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('W').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Zn').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Zn').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Zn').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Pb').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Pb').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Pb').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Ti').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('Ti').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Ti').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Sr').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Sr').get('minmax').get('max').setValue(val.min)
        }
    let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Sr').get('mean').setValue(num)
        // console.log(val)
      }
    );

    /*
   // this.alloyForm.get('TLcalculatedValues').get('TL_REF').setValue(14.45-(parseInt(this.alloyForm.get('chemistry').get('C').get('mean').value))-0.25*(parseInt(this.alloyForm.get('chemistry').get('Si').get('mean').value))-0.5*-(parseInt(this.alloyForm.get('chemistry').get('P').get('mean').value))/0.0089)
   
    //for calculating TL reference value (14/05)

    this.alloyForm.get('chemistry').valueChanges.subscribe(
    val => {
    this.alloyForm.get('TLcalculatedValues').get('TL_REF').setValue(14.45-(parseInt(this.alloyForm.get('chemistry').get('C').get('mean').value))-0.25*(parseInt(this.alloyForm.get('chemistry').get('Si').get('mean').value))-0.5*-(parseInt(this.alloyForm.get('chemistry').get('P').get('mean').value))/0.0089)
    });
    */

    this.alloyForm.get('grade').valueChanges.subscribe(
      val => {
        ////console.log(val)
        this.alloyForm.get('calculatedValues').get('GRADE').setValue(val)
      }
    );


  }
  onItemSelect(item: any) {
    ////console.log(item);
  }
  onSelectAll(items: any) {
    ////console.log(items);
  }
  resetForm(){
    this.alloyForm.reset();
  }

  switchEdit(event){
   //console.log(event)
    this.editGELWEL = !this.editGELWEL
  }

}
